const translations = {
  "slider.appealsNotFound": "Active referrals not found",
  "slider.requestsNotFound": "Active requests not found",
  "slider.consultationsNotFound": "Active consultations not found",
  "slider.detailedInformation": "Detailed information",
  "slider.uploadDocumentation": "Upload Documentation",
  "slider.request": "Request",
  "slider.medicalService": "Medical service provided",
  "slider.ambulatory": "Ambulatory",
  "slider.policyNumber": "Policy number",
  "slider.createDate": "Created date",
  "slider.requestedAmount": "Requested amount",
  "slider.reimbursedAmount": "Reimbursed amount",
  "slider.gel": "GEL",
  "slider.consultationDetails": "Consultation details",
  "slider.consultationType": "Consultation type",
  "slider.shareInfo": "Share prescription/test results with your doctor",
  "slider.cancelConsultation": "Cancel consultation",
  "slider.noConsultations": "Active scheduled consultations not registered",
  "slider.bookingAppointment": "Booking doctor's appointment",
  "slider.visitDetails": "Visit details",
  "slider.cancelVisit": "Cancel visit",
  "slider.shareDetailsToDoc":
    "Share the prescription/test results to the doctor",
  "slider.formDetails": "Form 100/medical prescription",
  "slider.additionalInputDetails": "Other (test results, X-ray etc.)",
  "slider.sending": "Send",
  "slider.outpatientDentistryMedicines": "Outpatient/Dentistry/Medicines",
  "slider.hospitalizationLabor": "Hospitalization/birth",
  "slider.other": "Other",
  "slider.consultationCode": "Reservation Code",
  "service.policyService": "Policy Service",
  "service.compensatedAmount": "Compensated Amount",
  "service.coveragePercent": "Coverage Percent",
  "service.createDate": "Create Date",
  "service.medicament": "Medicament",
  "service.nonProvider": "Non Provider",
  "service.payedAmmount": "Payed Ammount",
  "service.provider": "Provider",
  "service.rejectComment": "Correction Comment",
  "service.treatment": "Treatment",
  "service.unregisteredMedicine": "Unregistered Medicine",
  "service.leaveUsComment": "Leave us a comment",
  "service.correctionCommentDetailedReason": "Detailed reason for correction",
  "slider.requestAppeal": "Referral request",
  "slider.requestCompensation": "Reimbursement request",
  "slider.requestAppointment": "Book an appointment",
};

export default translations;
